import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGroup = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "path-1-inside-1_775_21829",
		fill: "white",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			rx: 2
		})
	}), /* @__PURE__ */ _jsx("rect", {
		width: 24,
		height: 24,
		rx: 2,
		stroke: "var(--colors-grey-1)",
		fill: "none",
		strokeWidth: 5,
		strokeLinecap: "square",
		strokeLinejoin: "round",
		strokeDasharray: "5 8",
		mask: "url(#path-1-inside-1_775_21829)"
	})]
});
export default SvgGroup;
